module.exports = __webpack_public_path__ + "static/media/CorrectBling1.8075d0ea.mp3";